import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUser, updateUser } from 'actions/user';
import { getUser, getErrorMessage, getIsUserUpdating } from 'reducers/user';
import {
  getIsQuestionnaireUpdated,
  getSubOtherValidity,
  getOtherValidity,
} from '../../../reducers/questionnaire';

import {
  requestFetchQuestionnaireAnswers,
  requestFetchQuestionnaire,
} from '../../../actions/questionnaire';
import { hideModal, showModal } from '../../../actions/modal';

import Person from '../../../components/Pages/ProfileEdit/Person';

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    errorOnUpdate: getErrorMessage(state, 'update'),
    isQuestionnaireUpdated: getIsQuestionnaireUpdated(state),
    subOtherValidity: getSubOtherValidity(state),
    otherValidity: getOtherValidity(state.questionnaire),
    isUserUpdating: getIsUserUpdating(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUser,
      requestFetchQuestionnaire,
      requestFetchQuestionnaireAnswers,
      updateUser,
      hideModal,
      showModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Person);
